import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { ExportExcelItemGroup } from "./ExportExcelItemGroup";
import { exportPdf } from "utils";
import { ExportPdfItemGroup } from "./ExportPdfItemGroup";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportItemGroup(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data: dataList } = useListExportNew("register", {
        build: fill.build,
        buy: fill.buy,
        group_id: fill.group_id,
        sell: fill.sell,
        inv: fill.inv,
        jumlah_item: amount
    });

    return (
        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount} 
            setAmount={setAmount}
            title="Item Group"
            type={props.type as "excel" | "pdf"}
            total={dataList.total_record}
            onExport={(amount) => {

                if (props.type === "excel") {
                    ExportExcelItemGroup({
                        data: dataList.items,
                        tableActive: activeColumn!,
                    })
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdfItemGroup data={dataList.items} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_group" })
                }
            }}
        />
    )
}